import request from '@/config/axios'

/** 1=快捷金刚 2=营销三入口 */
export const HOME_ENTRY_SLOT = {
  QUICK: 1,
  PROMO: 2
} as const

export interface HomeEntryVO {
  id?: number
  slot: number
  title: string
  subtitle?: string
  iconUrl?: string
  url?: string
  badgeText?: string
  sort: number
  status: number
  memo?: string
  createTime?: string
}

export const getHomeEntryPage = async (params) => {
  return await request.get({ url: `/promotion/home-entry/page`, params })
}

export const getHomeEntry = async (id: number) => {
  return await request.get({ url: `/promotion/home-entry/get?id=` + id })
}

export const createHomeEntry = async (data: HomeEntryVO) => {
  return await request.post({ url: `/promotion/home-entry/create`, data })
}

export const updateHomeEntry = async (data: HomeEntryVO) => {
  return await request.put({ url: `/promotion/home-entry/update`, data })
}

export const deleteHomeEntry = async (id: number) => {
  return await request.delete({ url: `/promotion/home-entry/delete?id=` + id })
}
